export default "__VITE_ASSET__96d78479__"